import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const textStyle = css`
  transition: all 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
    background: ${theme.colors.text.highlight};
    color: ${theme.colors.white};
  }
`;

export const tooltipBaseStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  .copy-status-icon {
    fill: ${theme.colors.white};
  }
`;

export const tooltipCopiedStyle = css`
  .copy-status-icon {
    fill: ${theme.colors.success[50]};
  }
`;

export const buttonStyle = css`
  align-items: center;
  display: flex;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(1.5)};
  width: auto;
  .copy-icon {
    margin-left: 0;
  }
`;

export const noMarginStyle = css`
  margin: 0;
`;
